export const getCoverageZones = state => state.coverageZones.coverageZones;
